<template>
    <main id="detail-redeem-wrapper">
        <div id="detail-redeem-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    { title: 'HCID', url: '/hcid', status: false },
                    { title: 'Tukar Poin', url: '/tukar-poin', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div class="row justify-content-center">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8 py-5 title-order">
                                <div class="row">
                                    <div class="col">
                                        <h2 class="title">Alpinestar Andes V2 Jacket</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <img src="/images/coin.png" alt="coin" class="coin-img pr-1">
                                        <span class="amount-point">1733</span> <span class="text-point">Poin</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <img class="card-img-top img-card" src="/images/tukar-poin-1.png" alt="Card image cap">
                            </div>
                        </div>
                    </div>
                    <hr class="divider">
                    <div class="container">
                        <div class="row">
                            <div class="col align-self-center">
                                <a href="" class="sharebtn"><span><i class="ion-android-share-alt"></i></span></a>
                            </div>
                            <div class="col text-right">
                                <a href="/form-alamat" class="btn btn-redeem py-2">Redeem</a>
                            </div>
                        </div>
                    </div>
                    <hr class="divider">
                    <div class="container my-5">
                        <div class="row">
                            <div class="col">
                                <div class="row py-2">
                                    <div class="col">
                                        <h3 class="title-desc">Deskripsi</h3>
                                    </div>
                                </div>
                                <div class="row py-2">
                                    <div class="col">
                                        <p class="content-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam enim eleifend aliquet feugiat non auctor mauris. Et, id malesuada commodo, diam pellentesque. Nunc augue hac eget et id dignissim arcu molestie. Sed massa arcu consequat turpis interdum ultricies. Morbi at malesuada faucibus accumsan eget tortor egestas. Egestas accumsan pulvinar mauris, convallis augue porttitor tempor, tortor at. In quis lorem nisl, fusce. Libero, in mattis sed aenean dui, hendrerit id. Nunc, tellus parturient proin rhoncus turpis nunc sit. Malesuada cursus tincidunt turpis velit at felis laoreet. Vel velit amet mauris faucibus donec senectus. Egestas ac nulla pellentesque velit cras aenean nam. Auctor dui maecenas dui, posuere fermentum. Habitant pellentesque pretium sollicitudin faucibus.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";

export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            mobile: false
        };
    },
    created() {
        this.mobile = isMobile;
    },
    methods: {}
};
</script>

<style scoped lang="scss">
#detail-redeem-page{
    background: #1A1A1A;
    .sharebtn{
        i{
            color: #FFFFFF;
        }
    }
    .title{
        font-family: Manrope;
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 42px;
        color: #FFFFFF;
    }
    .amount-point{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #FFEB36;
    }
    .text-point{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #8C8C8C;
    }
    .coin-img{
        max-height: 15px;
    }
    .img-card{
        border-radius: 10px;
        max-height: 360px;
    }
    .divider{
        opacity: 0.15;
        border: 1px solid #DBDBDB;
    }
    .btn-redeem{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
        background: #E61B33;
        border-radius: 10px;
        width: 204px;
    }
    .title-desc{
        font-family: Manrope;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
    .content-desc{
        font-family: Manrope;
        font-style: normal;
        font-weight: 300;
        font-size: 15px;
        line-height: 24px;
        color: #B4B4B4;
    }
    @media (max-width: 768px) {
        .title-order{
            order: 12;
        }
    }
}
</style>
